import { Tooltip as MtTooltip, TooltipProps as MtTooltipProps } from "@mantine/core";
import type { FC, ReactNode } from "react";

import { Color } from "src/theme";

const TOOLTIP_BODY_STYLES = {
    backgroundColor: Color.white,
    border: `1px solid ${Color.gray25}`,
    color: Color.black,
    boxShadow: "rgba(148, 163, 187, 0.32) 0px 4px 25px;",
} as const;

type TooltipProps = {
    content: ReactNode;
    withArrow?: boolean;
    position?: MtTooltipProps["position"];
    allowPointerEvents?: boolean;
    closeDelay?: number;
};

export const Tooltip: FC<TooltipProps> = ({ children, content, withArrow, position, allowPointerEvents, closeDelay }) => (
    <MtTooltip
        styles={{
            body: TOOLTIP_BODY_STYLES,
        }}
        withArrow={withArrow}
        position={position}
        allowPointerEvents={allowPointerEvents}
        closeDelay={closeDelay}
        label={content}
    >
        {children}
    </MtTooltip>
);
